import type { UserModel } from 'core/services';
import type { UserRoles } from '../types';

export class UserAccessModel {
  roles: UserRoles[];

  user: UserModel;
}
